import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-compliance-settings',
  templateUrl: './compliance-settings.component.html',
  styleUrls: ['./compliance-settings.component.scss']
})
export class ComplianceSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
